<template>
  <div
      v-if="showComponent && onReady"
      :key="componentRefresh"
      :id="`ks-list-${_uid}`"
  >

    <div>
      <slot/>
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';
import onMountedDataProvider from '../../mixins/onMountedDataProvider';

export default {
  name: 'ks-list',
  mixins: [checkPermissions, onMountedDataProvider],
  props: {
    dataProvider: {type: String, required: true},

    defaultViewType: {type: String, default: 'table'},
    stickyHeader: {type: Boolean, default: false},
    /*headerClasses: {type: String, default: ''},
    showNewButton: {type: Boolean, default: false},
    newButtonLabel: {type: String, default: null},
    newButtonIcon: {type: String, default: 'fas fa-plus'}*/
  },
  computed: {
   /* leftDrawerOpen() {
      return app.leftDrawerStatus.isOpen
    },
    rightDrawerOpen() {
      return app.rightDrawerStatus.isOpen
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    hasSlotHeader() {
      return !!this.$slots.header;
    },*/
    list() {
      return this.data_provider_ref ? this.data_provider_ref.list : [];
    },
    loading() {
      return this.data_provider_ref ? this.data_provider_ref.l_loading : true;
    }
  },
  methods: {
    getComponentConfiguration() {
      let config = {'activeViewType': this.activeViewType};
      if (this.activeViewComponent) {
        return {
          ...config,
          ...this.activeViewComponent.getComponentConfiguration()
        };
      }
      return config;
    },
    setComponentConfiguration(config) {
      try {
        this.setActiveViewType(config.activeViewType);
        setTimeout(() => {
          console.log("this.activeViewComponent", this.activeViewComponent);
          this.activeViewComponent.setComponentConfiguration(config);
        }, 100);
      } catch (err) {
        throw err;
      }
    },
    async setActiveViewType(type, beforeViewTypeChange = null) {
      try {
        this.activeViewType = type;
        if (beforeViewTypeChange !== null && typeof beforeViewTypeChange == 'function') await beforeViewTypeChange(this, type);
      } catch (err) {
        console.log(err);
      }
    }
  },
  async mounted() {
    await this.onMountedDataProvider();
    $(document).on('click', `#ks-grid-column-hidden-menu-${this._uid}`, (e) => {
      e.stopPropagation();
    });
    let element = document.getElementById(`ks-list-${this._uid}`);
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 1.0]
    };
    let handleIntersect = (entries, observer) => {
      let _this = this;
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          _this.$emit('onVisible', {'el': this, 'isVisible': true});
        } else if (entry.intersectionRatio === 0.0) {
          _this.$emit('onVisible', {'el': this, 'isVisible': false});
        }
      });
    }
    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(element);
  },
  data() {
    return {
      view_type_buttons: [
        {'active_view_type': 'table', 'icon': 'fas fa-bars fa-fw'},
        {'active_view_type': 'gallery', 'icon': 'fas fa-th fa-fw'},
        {'active_view_type': 'grid', 'icon': 'fas fa-table fa-fw'},
        {'active_view_type': 'map', 'icon': 'fas fa-map fa-fw'},
        {'active_view_type': 'calendar', 'icon': 'far fa-calendar-alt fa-fw'},
        {'active_view_type': 'chart-bar', 'icon': 'fas fa-chart-bar fa-fw'},
        {'active_view_type': 'chart-pie', 'icon': 'fas fa-chart-pie fa-fw'},
        {'active_view_type': 'chart-line', 'icon': 'fas fa-chart-line fa-fw'},
      ],
      timers: {},
      counters: {},
      activeViewType: this.defaultViewType,
      searchOnDrag: true,
      columns: {},
      activeViewComponent: null
    }
  }
}
</script>
